import React ,{useEffect,useState} from "react";
import {Button,notification,Result,message,Modal,Row,Col, Form, Input} from "antd";
import axios from 'util/Api'
import config from "../util/ApiforContext"
import { CheckOutlined } from '@ant-design/icons';
import ClientCaptcha from "react-client-captcha"
import {useHistory} from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import Screen from '../util/Extensions/Screens'
const FormItem = Form.Item;
const NewPassword = (props) => {
const history = useHistory();
const [isHavePsrGuid, setIsHavePsrGuid] = useState(true);
const [loading, setLoading] = useState(false);
const [captchaCode, setCaptchaCode] = useState("");
const [captchaKey, setCaptchaKey] = useState(0);
const [smsPassword, setSmsPassword] = useState("");
const {initialMinute = 0} = props;
const [smsValue, setSmsValue] = useState("");
const [ minutes, setMinutes ] = useState(initialMinute);
const [seconds, setSeconds ] =  useState(180);
const [errorText, setErrorText ] =  useState("");
const [userPassword, setUserPassword ] =  useState("");
const [visible, setVisible] = useState(false);
const [loadingBtn, setLoadingBtn] = useState(false);
const [recaptchaToken, setRecaptchaToken ] =  useState("");

useEffect(()=>{
  let myInterval = setInterval(() => {
          if (seconds > 0) {
              setSeconds(seconds - 1);
          }
          if (seconds === 0) {
              if (minutes === 0) {
                handleCancel()
              } else {
                  setMinutes(minutes - 1);
                  setSeconds(59);
              }
          } 
      }, 1000)
      return ()=> {
          clearInterval(myInterval);
        };
  });
  const [form] = Form.useForm();
  const showModal = () => {
    setSeconds(180)
    setErrorText("")
    setVisible(true)
  }
  const setCode = captchaCode => {
    setCaptchaCode(captchaCode)
  }
  
const recaptchaRef = React.createRef();

function onChange(value) {
  setRecaptchaToken(value);
}
  const handleSubmit = (values) => {
    if(values.Sms === undefined || values.Sms === ""){
      setErrorText("*Lütfen giriş yapınız.")
      setLoadingBtn(false)
      setCaptchaKey(captchaKey + 1)
    }else{
      axios.post(`${config.apiUrl}/Auth/PsrRegex`,{
        SecurityKey: values.Sms,
        PsrGuid:props.match.params.psrGuid,
        PsrForRegex:userPassword,
        IsNewPassword:true
      },config.headers)
      .then(res => {
        if(res.data === true){
          openNotificationWithIcon('success');
          setTimeout(function () {
           history.push('/signin')
          }.bind(this), 2000)
      }
      }).catch(
        error => {
          if(error.response.status === 406){
            error.response.data.data.map((item)=>{
              errorList.push(item);
            })
            errorListNotification('error')
            setLoading(false)
            setLoadingBtn(false)
            handleCancel()
            setCaptchaKey(captchaKey + 1)
            window.grecaptcha.reset();
            setRecaptchaToken("");
          }else{
            openNotificationWithIconWarning('error')}
            setLoading(false)
            setLoadingBtn(false)
            setCaptchaKey(captchaKey + 1)
            window.grecaptcha.reset();
            setRecaptchaToken("");
           }
    );        
    setSmsValue(values.Sms)
  }
  };
  const handleCancel = () => {
    setVisible(false)
    if(handleCancel){
      setLoading(false)
    }
    setLoadingBtn(false)
  };
var errorList = [];
const captchaError = type => {
  notification[type]({
    message: 'Hata',
    description:
      'Girilen kod hatalı, tekrar deneyiniz.',
      duration: 5,
  });
};
const errorListNotification = type => {
  errorList.map((item)=> {
    notification[type]({
      message: 'Hata',
      description:
      item
       ,
        duration: 4,
    });
  })
};
  useEffect(() => {
    errorList = []
    axios.get(`${config.apiUrl}/auth/IsHavePsrGuid?PsrGuid=${props.match.params.psrGuid}`,
     {})
     .then(res => {
        if(res.data){
          setIsHavePsrGuid(true)
        }
         }).catch(
          error => {
            if(error.response.status === 406){
              error.response.data.data.map((item)=>{
                errorList.push(item);
              })
              errorListNotification('error')
              setLoadingBtn(false)
              setLoading(false)
              history.push("/signin")
             }else{
              openNotificationWithIconWarning('error')}
              setLoadingBtn(false)
              setLoading(false)
             }
      );
  }, [])
  const onFinishFailed = errorInfo => {
    setLoading(false)
  };
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}
let hide = () => {};
  const onFinish = values => {
      axios.post(`${config.apiUrl}/Auth/PsrRegex`,{
        PsrGuid:props.match.params.psrGuid,
        PsrForRegex :values.password,
        RecaptchaToken: recaptchaToken
      },config.headers)
      .then(res => {
        if(res.data === true){
             setUserPassword(values.password)
             showModal()
      }
      }).catch(
        error => {
          if(error.response.status === 406){
            error.response.data.data.map((item)=>{
              errorList.push(item);
            })
            errorListNotification('error')
            setLoading(false)
            setLoadingBtn(false)
            handleCancel()
            setCaptchaKey(captchaKey + 1)
            window.grecaptcha.reset();
            setRecaptchaToken("");
          }else{
            openNotificationWithIconWarning('error')}
            setLoading(false)
            setLoadingBtn(false)
            setCaptchaKey(captchaKey + 1)
            window.grecaptcha.reset();
            setRecaptchaToken("");
           }
    );
  };
  function onSubmits() {
    const recaptchaValue = recaptchaRef.current.getValue();
    props.onSubmit(recaptchaValue);
  }
  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Şifre güncelleme işlemi başarı ile gerçekleşti.',
        duration: 2,
    });
  };
  const NotSamePasswordWarning = type => {
    notification[type]({
      message: 'HATA',
      description:
        'Şifreler aynı değil.',
        duration: 2,
    });
  };
  const openNotificationWithIconWarning = type => {
    notification[type]({
      message: 'HATA',
      description:
        'Şifre güncelleme işlemi sırasında bir hata oluştu.',
        duration: 2,
    });
  };
  return (
    isHavePsrGuid === true ?
    <div className="gx-login-container"  >
      <div className="gx-login-content">

        <div className="gx-login-header">
            <img src={require("assets/images/AkodeRed.png")} alt="paratic" title="paratic" style={{width:'40%'}}/>
        </div>
        <div className="gx-mb-4">
          <h3>Şifre Oluştur</h3>
          <p>Hesabınızın şifresini giriniz.</p>
        </div>

        <Form
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0">

          <FormItem rules={ [{required: true, message: 'Lütfen şifrenizi giriniz.'}]} name="password">
            <Input className='gx-input-lineheight' autoComplete="off" type="password" 
            placeholder="Şifrenizi Giriniz" onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }} 
            onKeyDown={ (evt) => evt.keyCode === 32 && evt.preventDefault() }/>
          </FormItem>

          <FormItem rules={ [{required: true, message: 'Lütfen şifrenizi giriniz.'}]} name="confirm">
            <Input autoComplete="off" className='gx-input-lineheight' placeholder="Şifrenizi Tekrar Giriniz" type="password" onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }} onKeyDown={ (evt) => evt.keyCode === 32 && evt.preventDefault() }/>
          </FormItem>
           
          <form onSubmit={onSubmits} >
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6LfX1CIdAAAAAC9TS6J53DDfVYb4Xnn7gWJSWCdd"
            type={"image"}
            hl={"tr"}
            style={{marginLeft:20,marginBottom:20}}
            onChange={onChange}
          />
          </form>

        <Row>
          <Col span={12}>
          <FormItem>
            <Button type="primary" icon={<CheckOutlined />} htmlType="submit"  onClick={() => setLoading(true)} loading={loading}>
              Oluştur
            </Button>
                  </FormItem>
          </Col>
          <Col span={12}>
          <a href="/signin">
                      Giriş Sayfasına Dön
                    </a>
          </Col>
        </Row>
        </Form>
        <Modal 
      visible={visible} onOk={form.submit} okButtonProps={{hidden:true}} cancelButtonProps={{hidden:true}} footer={null} onCancel={handleCancel}>
      <p style={{marginTop:10,textAlign:'center',fontSize:16}}> Lütfen telefonunuza gelen şifreyi <b>{seconds}</b> saniye içinde girin; </p>
     
      <Form
                   onFinish={handleSubmit}
                    >
               
                <Row style={{marginBottom: -25,marginLeft:32}}>
               
                <Col span={15}>
                <Form.Item
                name="Sms"
                >
                <Input 
                 onKeyPress={(e) => { (e.key === 'e' || e.key === "E") && e.preventDefault(); }}
                onChange={() => { setErrorText("")}} type='number'/>
                </Form.Item>  
                </Col>
                <Col span={6}>
                <Form.Item  >
                <Button type="primary" htmlType="submit" onClick={() => setLoadingBtn(true)} loading={loadingBtn}>
                    Onayla
                </Button>
                </Form.Item>
                </Col>
                <Col span={3}></Col>
                </Row>
              </Form>
              <p style={{color:'darkred',textAlign:'center',fontWeight:600}}>{errorText}</p>
      </Modal>
      </div>
    </div>
    :
    <div>
                <Result
                    status="404"
                    title="404"
                    subTitle="Üzgünüm, böyle bir kullanıcı bulamadım."
                    extra={<Button type="primary" href='/signin'> Giriş Sayfasına Dön</Button>}
                />
            </div>
  );
};

export default NewPassword;
